import {useEffect, useState} from 'react'
import clsx from 'clsx'
import {KTSVG, UserAvatar} from '../../../helpers'
import {
  HeaderUserMenu,
  Search,
  ThemeModeSwitcher,
  Helper,
  HeaderNotificationsMenu,
} from '../../../partials'
import {useLayout} from '../../core'
import {useAuth} from '../../../../app/modules/auth'
import {TaskModal} from '../../../partials/modals/task/TaskModal'
import {useMutation} from 'react-query'
import axios from 'axios'
import {ReleaseNoteModal} from '../../../partials/modals/release-note/ReleaseNoteModal'
import {ContractAiSuggestionsModal} from '../../../partials/modals/contracts/ContractAiSuggestionsModal'
import {SpreadsheetImportMappingModal} from '../../../../app/modules/project/components/spreadsheet-import/SpreadsheetImportMappingModal'
import {Settings} from '../../../partials/layout/settings/Settings'
import {OPEN_NEW_TASK_EVENT} from '../../../../app/modules/onboarding/openNewTask'

const itemClass = 'ms-2 ms-lg-3'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted w-40px h-40px'
const userAvatarClass = 'symbol-35px symbol-md-40px'
const btnIconClass = 'svg-icon-1'
const API_URL = process.env.REACT_APP_API_URL

const Navbar = () => {
  const {config} = useLayout()
  const {currentUser} = useAuth()
  const [showModalStepper, setShowModalStepper] = useState<boolean>(false)

  const openEditModal = () => {
    setShowModalStepper(true)
  }

  // Outras telas (ex.: checklist de primeiros passos) abrem o mesmo modal de nova tarefa.
  useEffect(() => {
    if (currentUser?.external_user) return
    const open = () => setShowModalStepper(true)
    window.addEventListener(OPEN_NEW_TASK_EVENT, open)
    return () => window.removeEventListener(OPEN_NEW_TASK_EVENT, open)
  }, [currentUser?.external_user])

  const {mutateAsync: readNotificationsFn} = useMutation((notifications: any) => {
    const ids = notifications.map((notification: any) => notification.id)
    return axios.patch(`${API_URL}/api/notifications/${currentUser?.id}/mark-as-read`, {
      notificationIds: ids,
    })
  })

  return (
    <div className='app-navbar flex-shrink-0'>
      {!currentUser?.external_user && (
        <div className={clsx('app-navbar-item align-items-stretch', itemClass)} id='navbar-search'>
          <Search />
        </div>
      )}

      {!currentUser?.external_user && (
        <div className={clsx('app-navbar-item', itemClass)} id='navbar-new-task'>
          <div
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            onClick={openEditModal}
            className={btnClass}
          >
            <i className='bi bi-plus-circle fs-3'></i>
          </div>
          <TaskModal show={showModalStepper} handleClose={() => setShowModalStepper(false)} />
        </div>
      )}

      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTSVG path='/media/icons/duotune/communication/com012.svg' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
      </div> */}

      <div
        id='navbar-notifications'
        className={clsx('app-navbar-item', itemClass)}
        onClick={() =>
          currentUser?.unread_notifications?.length === 0
            ? {}
            : readNotificationsFn(currentUser?.unread_notifications)
        }
      >
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={`position-relative ${btnClass}`}
        >
          <i className='bi bi-bell fs-3'></i>
          {currentUser?.unread_notifications?.length !== 0 && (
            <span className='bullet bullet-dot bg-danger h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
          )}
        </div>
        <HeaderNotificationsMenu />
      </div>

      {/* Tema: escondido no mobile (fica no menu do avatar) — é ação de baixa frequência,
          não vale disputar espaço com os ícones essenciais numa tela estreita. */}
      <div id='navbar-theme' className={clsx('app-navbar-item d-none d-lg-flex', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-custom')} />
      </div>
      <div id='navbar-helper' className={clsx('app-navbar-item d-none d-lg-flex', itemClass)}>
        <Helper />
      </div>
      {/* Engrenagem: pra usuário comum é só um atalho pra Notificações, já coberto pelo
          sino ao lado — escondido no mobile só nesse caso pra não duplicar. Admin/gestor
          têm atalhos reais aqui (Etapas, Integrações, Modelos...), então continuam vendo. */}
      <div
        id='navbar-settings'
        className={clsx(
          'app-navbar-item',
          {'d-none d-lg-flex': !currentUser?.administrator && !currentUser?.manager},
          itemClass
        )}
      >
        <Settings />
      </div>

      <div id='navbar-avatar' className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol position-relative', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <UserAvatar
            name={currentUser?.name ?? ''}
            avatar={currentUser?.avatar}
            sizeClass={userAvatarClass}
            imgClassName='object-fit-cover'
          />
        </div>
        <HeaderUserMenu />
      </div>

      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n4' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTSVG path='/media/icons/duotune/text/txt001.svg' className={btnIconClass} />
          </div>
        </div>
      )}

      <ReleaseNoteModal />
      <ContractAiSuggestionsModal />
      <SpreadsheetImportMappingModal />
    </div>
  )
}

export {Navbar}
